import getConfig from 'next/config';
import axios from 'axios';

const { publicRuntimeConfig } = getConfig();
export const CREDIT_URL = `${publicRuntimeConfig.apiRootUrl}/credit/v1/`;

const http = axios.create({
  baseURL: CREDIT_URL,
  headers: { 'Content-Type': 'application/json' }
});

async function getActiveCreditApplication({
  authToken
}: {
  authToken: string;
}) {
  return http.get('applications/active', {
    headers: {
      'Access-Control-Allow-Origin': '*',
      authorization: authToken
    }
  });
}

async function startCreditApplication({ authToken }: { authToken: string }) {
  return http.post(
    'applications/start',
    {},
    {
      headers: {
        'Access-Control-Allow-Origin': '*',
        authorization: `Bearer ${authToken}`
      }
    }
  );
}

async function submitCreditApplication({ authToken }: { authToken: string }) {
  return http.post(
    'applications/submit',
    {},
    {
      headers: {
        'Access-Control-Allow-Origin': '*',
        authorization: `Bearer ${authToken}`
      }
    }
  );
}

async function submitHousingInformation({
  authToken,
  monthlyHousingCost
}: {
  authToken: string;
  monthlyHousingCost: number;
}) {
  return http.post(
    'applications/housing-information',
    { monthlyHousingCost },
    {
      headers: {
        'Access-Control-Allow-Origin': '*',
        authorization: `Bearer ${authToken}`
      }
    }
  );
}

async function submitEmploymentInformation({
  authToken,
  yearlyIncome,
  employmentStatus,
  nonTaxableYearlyIncome
}: {
  authToken: string;
  yearlyIncome: number;
  employmentStatus: string;
  nonTaxableYearlyIncome: boolean;
}) {
  return http.post(
    'applications/employment-details',
    { yearlyIncome, employmentStatus, nonTaxableYearlyIncome },
    {
      headers: {
        'Access-Control-Allow-Origin': '*',
        authorization: `Bearer ${authToken}`
      }
    }
  );
}

async function getApprovalDocs({
  authToken,
  documentsType
}: {
  authToken: string;
  documentsType: string;
}) {
  return http.get(`applications/documents/${documentsType}`, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      authorization: `Bearer ${authToken}`
    }
  });
}

async function acceptPreApprovalDocs({ authToken }: { authToken: string }) {
  return http.post(
    'applications/documents/accept',
    { documentsType: 'pre_terms' },
    {
      headers: {
        'Access-Control-Allow-Origin': '*',
        authorization: `Bearer ${authToken}`
      }
    }
  );
}

export default {
  getActiveCreditApplication,
  startCreditApplication,
  submitCreditApplication,
  submitHousingInformation,
  submitEmploymentInformation,
  getApprovalDocs,
  acceptPreApprovalDocs
};
